import { createContext, useContext } from "react";

import type { DirectionBounds, Gesture, Point } from "../types.ts";

export type PanContext = {
  pan: Point;
  scaledPan: Point;
  scaledBounds: DirectionBounds;
  onPanDrag: (pan: Point) => void;
  onPanReset: () => void;
  onPanGesture: (gesture?: Gesture) => void;
};

export const PanContext = createContext<PanContext | undefined>(undefined);
PanContext.displayName = "PanContext";

export const usePan = () => {
  const panContext = useContext(PanContext);
  if (!panContext) {
    throw new Error(`Expected PanContext in component tree.`);
  }
  return panContext;
};
